import { useState } from "react";
import { requestSignin } from "../api";
import { LockIcon } from "./icons";

/** Signed-out view: magic-link request. No password is ever collected. */
export function SignIn() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState<
    { kind: "ok" | "err"; text: string; link?: string } | null
  >(
    new URLSearchParams(location.search).get("auth") === "invalid"
      ? {
          kind: "err",
          text: "That sign-in link has expired or was already used. Request a new one below.",
        }
      : null,
  );

  async function submit(ev: React.FormEvent) {
    ev.preventDefault();
    const addr = email.trim();
    if (!addr) return;
    setBusy(true);
    setNote(null);
    try {
      const d = await requestSignin(addr);
      setNote({ kind: "ok", text: d.message, link: d.dev ? d.link : undefined });
    } catch (e) {
      setNote({ kind: "err", text: String((e as Error).message || e) });
    }
    setBusy(false);
  }

  return (
    <section className="signin">
      <div className="icon">
        <LockIcon />
      </div>
      <h1>Sign in to your employee portal</h1>
      <p>
        Enter your company email and we will send you a one-time sign-in link. No password
        needed.
      </p>
      <form onSubmit={submit}>
        <input
          type="email"
          placeholder="you@yourcompany.com"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button disabled={busy}>Send me a sign-in link</button>
      </form>
      {note && (
        <div className={note.kind === "err" ? "note err" : "note"}>
          {note.text}
          {note.link && (
            <>
              <br />
              <a href={note.link}>Open your sign-in link (dev mode)</a>
            </>
          )}
        </div>
      )}
      <p className="foot">
        Access is limited to employees in your company's HR directory. The link is valid for
        15 minutes.
      </p>
    </section>
  );
}
